angular.module('lf.common')

.factory('bazaarvoiceService', function ($http, $q) {

  var bv = $.extend({}, lf.data.xhr.bazaarvoice, {
    apiversion: '5.4'
  });
  
  var bvParams = {
    passkey: bv.passKey,
    apiversion: bv.apiversion
  };
  
  return {
    getProductReviewSummary: getProductReviewSummary
  }
  
  function getProductReviewSummary (opts) {
    return getSummary(opts);
  }
  
  function getSummary (opts) {
    var apiUrl = bv.apiUrl + '/data/reviews.json';
    var params = $.param($.extend({}, bvParams, {
      filter: 'productid:' + opts.id,
      filteredstats: 'reviews',
      include: 'products',
      limit: 1
    }));
    
    var locale = bv.locale;
    
    if (['en', 'en_US'].indexOf(locale) > -1) {
      locale = 'en,en_US';
    } else if (['en_GB', 'en_AU', 'en_IE'].indexOf(locale) > -1) {
      locale = 'en_GB,en_AU,en_IE';
    }
    
    params = params + '&filter=contentlocale:' + locale;

    var deferred = $q.defer();
    
    $http.get(apiUrl + '?' + params)
      .success(function (data) {
        var result = {
          id: opts.id,
          locale: data.Locale,
          reviews: {
            totalCount: 0
          }
        };
        
        if (data.Errors.length) {
          console.warn('[bazaarvoiceService.getSummary] response obj `Errors`:', data.Errors);
          deferred.reject({msg: 'Fetch error', errors: data.Errors});
        } else {
          if (data.TotalResults) {
            var stats = data.Includes.Products[opts.id].FilteredReviewStatistics;
            $.extend(result.reviews, {
              totalCount: stats.TotalReviewCount || 0,
              overallRatingRange: stats.OverallRatingRange || 5,
              averageOverallRating: +(stats.AverageOverallRating || 0).toFixed(1),
              summary: (stats.RatingDistribution || []).reduce(function (summary, item) {
                summary[item.RatingValue] = item.Count;
                return summary;
              }, {1: 0, 2: 0, 3: 0, 4: 0, 5: 0})
            });
          }
          
          deferred.resolve(result);
        }
      })
      .error(function (data) {
        console.error('[bazaarvoiceService.getSummary] $http.get error:', data);
        deferred.reject(data);
      });
      
    return deferred.promise;
  }
  
});
